import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import { IGetAllServiceProps } from "@api/types/globalService.types";
import { getJourneyFrontendBootAPI } from "./journeyFrontend.api";
import { IJourneyFrontendBootResponseSchema } from "./journeyFrontend.types";
import { jsonUtility } from "@repo/utilities/json.utility.ts";

type IGetJourneyFrontendBootService = { journeyId: string } & Omit<
  IGetAllServiceProps,
  "page" | "per_page" | "stage_id" | "filters"
>;

const useGetJourneyFrontendBootService = ({
  journeyId,
  enableQuery = true,
  cacheKeys = [],
}: IGetJourneyFrontendBootService) => {
  return useQuery({
    queryKey: [...CACHE_KEYS.JOURNEY_FRONTEND_BOOT, journeyId, ...cacheKeys],

    queryFn: async (): Promise<{
      data: IJourneyFrontendBootResponseSchema;
    }> => {
      const response = await getJourneyFrontendBootAPI({
        journeyId,
      });

      const parsedLeadDetails = jsonUtility.safeJsonParse(
        sessionStorage.getItem("leadDetails")
      );

      if (parsedLeadDetails?.plans) {
        return {
          ...response,
          data: {
            ...response.data,
            plans: parsedLeadDetails.plans,
          },
        };
      } else {
        return response;
      }
    },

    enabled: enableQuery,
  });
};

export { useGetJourneyFrontendBootService };
